import React from "react";

const IF = (props) => props.condition && props.children;

export default IF;
